import "../../resources/css/search/search.css";
import { Label } from "../atoms/label";
import { OptionPullDown } from "../atoms/optionPullDown";

export const PullDownOptionForm = (props) => {
    const { divClass, selectClass, title, data, state, onChange, id, labelClassName, defaultValue, disabled } = props;
    return (
        <div className={divClass}>
            <Label className={labelClassName} label={title} />
            <OptionPullDown data={data} selectClass={selectClass} onChange={onChange} value={state} id={id} defaultValue={defaultValue} disabled={disabled}/>
        </div>
    );
};